import { render, staticRenderFns } from "./OneTimePassInputSection.vue?vue&type=template&id=55e72dbe&scoped=true"
import script from "./OneTimePassInputSection.vue?vue&type=script&lang=ts"
export * from "./OneTimePassInputSection.vue?vue&type=script&lang=ts"
import style0 from "./OneTimePassInputSection.vue?vue&type=style&index=0&id=55e72dbe&prod&lang=scss&scoped=true"
import style1 from "./OneTimePassInputSection.vue?vue&type=style&index=1&id=55e72dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e72dbe",
  null
  
)

export default component.exports